
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRainShowersDayColour as ObiLightningLightRainShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain-showers-day-colour.js';
 
 
 

 
 export const ObiLightningLightRainShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain-showers-day-colour',
   elementClass: ObiLightningLightRainShowersDayColourElement,
   events: {
     
   }
  });
 
 